import { useQuery } from "react-query";
import { apiRequest } from "../../../services/api";

export default function useGetScheduledAppointments() {
  const getScheduledAppointments = () => {
    return apiRequest("get", "appointments/scheduled");
  };
  return useQuery("scheduledAppointments", getScheduledAppointments);
}
